<div class="container-fluid" [style.background-image]="'url('+banner.image+')'">
  <div class="container">
    <h1 class="text-vineritic" [style.color]="banner.color">{{banner.title}}</h1>
  </div>
</div>